export const NOTIFICATION_REFRESH_MS = 10000;
export const NOTIFICATION_REMINDER_MS = 30000;
export const NOTIFICATION_SYNC_EVENTS = ["notificationSync", "noteRead", "inquiryRead"];

const positiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

export const notificationCounts = (payload = {}) => ({
  note: positiveNumber(payload.admin_note_count) + positiveNumber(payload.note_count) +
    positiveNumber(payload.unread_note_count),
  inquiry: positiveNumber(payload.admin_inquiry_answer_count),
});

export const notificationPresentation = (type) => type === "inquiry"
  ? { title: "고객센터 답변", message: "고객문의 답변이 도착했습니다.", to: "/customer-service-center" }
  : { title: "쪽지 알림", message: "새 쪽지가 도착했습니다.", to: "/notice-board" };
